// src/components/CookieBanner/CookieBanner.js
import React, { useState, useEffect } from 'react';
import './CookieBanner.css';

const CookieBanner = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const accepted = localStorage.getItem('cookiesAccepted');
    if (!accepted) {
      setShowBanner(true);
    }
  }, []);

  const handleClose = (value) => {
    localStorage.setItem('cookiesAccepted', value);
    // Auto close after 1 second
    setTimeout(() => {
      setShowBanner(false);
    }, 1000);
  };

  if (!showBanner) return null;

  return (
    <div className="cookie-banner">
      <div className="cookie-card animate-slide-up">
        <p className="cookie-text">
          We use cookies to enhance your experience. By continuing to visit this site, you agree to our use of cookies.
        </p>
        <p className="cookie-links">
          Click here to view our{' '}
          <a href="/privacy-policy" className="link-text" target="_blank" rel="noopener noreferrer">Privacy Policy</a>,{' '}
          <a href="/terms" className="link-text" target="_blank" rel="noopener noreferrer">Terms & Conditions</a>,{' '}
          <a href="/cookie-policy" className="link-text" target="_blank" rel="noopener noreferrer">Cookie Policy</a>.
        </p>
        <div className="cookie-buttons">
          <button className="cookie-btn accept" onClick={() => handleClose('true')}>Accept Cookies</button>
          <button className="cookie-btn reject" onClick={() => handleClose('rejected')}>Reject Cookies</button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
